const ImageIlustrationRepay = () => {
    return (
        <img
            src='/assets/ilustrations/repay.svg'
            style={{ width: "100%", height: "150px", marginBottom: "16px" }}
        />
    );
}

export default ImageIlustrationRepay;